<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div>
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="printAllLocationMovement('printLocationMovement')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllLocationMovement()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN'">
              <v-autocomplete
                v-model="queryParams.fromWarehouseId"
                :items="warehouseList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose From Warehouse..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                @change="getFromBinListByWarehouse(queryParams.fromWarehouseId)"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.fromBinId"
                :items="fromBinList"
                color="blue-grey lighten-2"
                :hide-no-data="true"
                label="Choose From Bin..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-on:change="checkSameBin()"
              ></v-autocomplete>
              <h3
                v-if="isError"
                style="color: #ff5252; font: 12px Roboto, sans-serif"
              >
                {{ error }}
              </h3>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete
                v-model="queryParams.toBinId"
                :items="toBinList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose To Bin..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-on:change="checkSameBin()"
              ></v-autocomplete>
              <h3
                v-if="isError"
                style="color: #ff5252; font: 12px Roboto, sans-serif"
              >
                {{ error }}
              </h3>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="serialNo"
                label="Serial No"
                type="text"
                v-model="queryParams.serialNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="referenceNo"
                label="Reference Isse No"
                type="text"
                v-model="queryParams.referenceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="locationMovementList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>
                  {{ props.item.issueDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.issueNo }}</td>
                <td>{{ props.item.serialNo }}</td>
                <td>
                  {{
                    props.item.fromWarehouseName + "/" + props.item.fromBinName
                  }}
                </td>
                <td>
                  {{ props.item.toWarehouseName + "/" + props.item.toBinName }}
                </td>
                <td>{{ props.item.referenceNo }}</td>
                <td>{{ props.item.refNo }}</td>
                <td>{{ props.item.description }}</td>
                <td>
                  {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  <v-btn
                    color="primary"
                    @click.stop="reprintLocationMovementInvoice(props.item.id)"
                    >REPRINT</v-btn
                  >
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.locationMovementDetailItems"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.productName }}</td>
                      <td class="text-xs">
                        {{ subprops.item.factorUnitName }}
                      </td>
                      <td class="text-xs">
                        {{ subprops.item.qty | decFormat(6) }}
                      </td>
                      <td class="text-xs">{{ subprops.item.qcNo }}</td>
                      <td class="text-xs">{{ subprops.item.batchNo }}</td>
                      <td class="text-xs">
                        {{ subprops.item.mfgDateInMilliSeconds | formatMsDate }}
                      </td>
                      <td class="text-xs">
                        {{ subprops.item.expDateInMilliSeconds | formatMsDate }}
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <div
      id="printLocationMovement"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Location Movement Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ this.clonequeryParams.fromDate | formatDate }}] To
          Date: [{{ this.clonequeryParams.toDate | formatDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 14px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Issue Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Issue No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Serial No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Reference No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Warehouse
              </th>
              <th style="border: 1px solid black; text-align: center">
                From/To Bin
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Unit</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
            </tr>
          </thead>
          <tbody>
            <span v-for="(item, index) in allLocationMovementList" :key="index">
              <tr style="border-bottom: 1px solid black">
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.issueDateInMilliSeconds | formatMsDate }}
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.issueNo }}
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.serialNo }}
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.referenceNo }}
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.fromWarehouseName }}
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  {{ item.fromBinName + "/" + item.toBinName }}
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: left"
                >
                  <div
                    style="height: 2rem"
                    v-for="detail in item.locationMovementDetailItems"
                    :key="detail"
                  >
                    {{ detail.productName + "(" + detail.productCode + ")" }}
                  </div>
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: center"
                >
                  <div
                    style="height: 2rem"
                    v-for="detail in item.locationMovementDetailItems"
                    :key="detail"
                  >
                    {{ detail.factorUnitName }}
                  </div>
                </td>
                <td
                  valign="top"
                  style="border: 1px solid black; text-align: right"
                >
                  <ul style="list-style-type: none">
                    <li
                      style="height: 2rem"
                      v-for="detail in item.locationMovementDetailItems"
                      :key="detail"
                    >
                      {{ detail.qty | decFormat(6) }}
                    </li>
                  </ul>
                </td>
              </tr>
            </span>
          </tbody>
        </table>
      </div>
    </div>
    <!-- dialog -->
    <LocationMovementExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></LocationMovementExcel>
  </v-container>
</template>

<script>
import LocationMovementExcel from "../../components/location-movement/LocationMovementExcel";
import { commonService } from "../../services/common-service";
import { locationMovementService } from "../../services/location-movement-service";
import { warehouseService } from "../../services/warehouse-service";
export default {
  name: "LocationMovementList",
  components: { LocationMovementExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    breadcrumbs: [
      {
        text: "Location Management",
        disabled: true,
      },
      {
        text: "Location Movement",
        disabled: true,
      },
    ],
    headers: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Serial No", value: "serialNo" },
      { text: "From Warehouse/Bin", value: "fromWarehouse.name" },
      { text: "To Warehouse/Bin", value: "toWarehouse.name" },
      { text: "Refercence Issue No", value: "referenceNo" },
      { text: "Refercence No", value: "referenceNo", sortable: false },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Reprint", align: "center", sortable: false },
    ],
    subHeaders: [
      { text: "Product Name", sortable: false },
      { text: "Factor/Unit", sortable: false },
      { text: "Qty", sortable: false },
      { text: "QC No", sortable: false },
      { text: "Batch No", sortable: false },
      { text: "MFG Date", sortable: false },
      { text: "EXP date", sortable: false },
    ],
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    rowsPerPageItems: [25, 50, 100],
    openDialog: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      serialNo: "",
      referenceNo: "",
      fromWarehouseId: "",
      toWarehouseId: "",
      fromBinId: "",
      toBinId: "",
      updateUserId: "",
      fromBinIds: [],
      toBinIds: [],
    },
    clonequeryParams: new Object(),
    showListLoading: false,
    printAllButtonLoading: false,
    isError: false,
    error: "",
    totalRows: 0,
    fromBinList: [],
    toBinList: [],
    warehouseList: [],
    locationMovementList: [],
    allLocationMovementList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getLocationMovementList();
      },
      deep: true,
    },
  },
  created() {
    this.getWarehouseList();
    if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.fromWarehouseId = this.user.shop.warehouseId;
      this.queryParams.toWarehouseId = this.user.shop.warehouseId;
    } else if (
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.fromWarehouseId = this.user.warehouseId;
      this.queryParams.toWarehouseId = this.user.warehouseId;
      if (this.user.role.roleName == "WAREHOUSE_STAFF") {
        //this.queryParams.updateUserId = this.user.id;
        this.fromBinList = this.user.selectedBinList;
        this.toBinList = this.user.selectedBinList;
        this.user.selectedBinList.forEach((v) =>
          this.queryParams.fromBinIds.push(v.id)
        );
        this.queryParams.toBinIds = this.queryParams.fromBinIds;
      }
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.fromWarehouseId) {
      this.queryParams.fromWarehouseId = Number(this.$route.query.fromWarehouseId);
    }
    if (this.$route.query.toWarehouseId) {
      this.queryParams.toWarehouseId = Number(this.$route.query.toWarehouseId);
    }
    if (this.$route.query.fromBinId) {
      this.queryParams.fromBinId = Number(this.$route.query.fromBinId);
    }
    if (this.$route.query.toBinId) {
      this.queryParams.toBinId = Number(this.$route.query.toBinId);
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.serialNo) {
      this.queryParams.serialNo = this.$route.query.serialNo;
    }
    if (this.$route.query.referenceNo) {
      this.queryParams.referenceNo = this.$route.query.referenceNo;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "location-movements",
        query: this.queryParams,
      });
      this.getLocationMovementList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    getWarehouseList() {
      return warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (
            this.user.roleName == "WAREHOUSE_MANAGER" ||
            this.user.roleName == "BRANCH_ADMIN"
          )
            this.getFromBinListByWarehouse(this.user.warehouseId);
          if (
            this.user.role.roleName == "PRODUCTION_MANAGER" ||
            this.user.role.roleName == "ASSET_MANAGER"
          )
            this.getFromBinListByWarehouse(this.user.shop.warehouseId);
        });
    },
    getLocationMovementList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      locationMovementService
        .getLocationMovements(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.locationMovementList = res.data.locationMovements;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getLocationMovementList();
    },
    getFromBinListByWarehouse(warehouseId) {
      let warehouse = commonService.search(
        "id",
        warehouseId,
        this.warehouseList
      );
      this.fromBinList = warehouse.binList;
      let findAll = {
        id: "",
        name: "---All---",
      };
      this.fromBinList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
      this.toBinList = this.fromBinList;
    },
    printAllLocationMovement(divName) {
      this.printAllButtonLoading = true;
      locationMovementService
        .getAllLocationMovementList(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allLocationMovementList = res.data.locationMovements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    reprintLocationMovementInvoice(id) {
      locationMovementService.printLocationMovementInvoice(id).then((res) => {
        var blob = res;
        commonService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    exportAllLocationMovement() {
      this.printAllButtonLoading = true;
      locationMovementService
        .exportAllLocationMovementExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    checkSameBin() {
      if (this.queryParams.fromBinId != "" || this.queryParams.toBinId != "") {
        if (this.queryParams.toBinId == this.queryParams.fromBinId) {
          this.isError = true;
          this.error = "To and From Bin must be different.";
        } else {
          this.isError = false;
        }
      }
    },
    onRegister() {
      this.$router.push("/location-movement/new");
    },
  },
};
</script>
